import React, { Component } from 'react';
import { storageRef, db } from '../Firebase/Firebase';
// import firebase from 'firebase'

export default class AddProjects extends Component {


    constructor(props) {
        super(props);
        this.state = {
            selectedImage: null,
            projectImgUrl: ' ',
            projectName: ' ',
            projectDescription: ' ',
            projectType: ' ',
            logo:''
        }
    }


    fileSelectedHandler = event => {
        console.log(event.target.files);
        this.setState({
            selectedImage: event.target.files[0]
        })
    }

    uploadImg = () => {
        const id = Math.random().toString(14).substring(2);

        return new Promise((resolve, reject) => {
            storageRef.child(`images/${this.state.selectedImage.name + id}.png`).put(this.state.selectedImage).then((image) => {
                image.ref.getDownloadURL().then(url => {
                    console.log("URL : " + url)
                    this.setState({
                        projectImgUrl: url
                    })
                    resolve(url)
                })
                // resolve("Uploaded")
            }).catch(err => reject(err))
        }
        )
    }

    addProject =  async() => {
        await this.uploadImg().then((d) => {

            alert(d);
            console.log("New URL : " + this.state.projectImgUrl)

        }
        ).then(() => {
            let project = {
                name: this.state.projectName,
                desc: this.state.projectDescription,
                img: this.state.projectImgUrl,
                type: this.state.projectType,
                logo:this.state.logo
            }
            // var newPostKey = db.ref().child('/Projects').push().key;

            // Write the new post's data simultaneously in the posts list and the user's post list.
            // var updates = {};
            // updates['/posts/' + newPostKey] = postData;
            // updates['/user-posts/' + uid + '/' + newPostKey] = postData;
            const id = db.ref('/Projects').push().key;

             db.ref('/Projects').child(id).set(project);
        })

    }


    render() {
        return (
            <section className="container">


                <div className="form-group">
                    <label for="exampleInputEmail1">Project Name</label>
                    <input type="text" className="form-control" placeholder="Enter Project Name" required
                        onChange={name => this.setState({ projectName: name.target.value })} />
                </div>
                <div className="form-group">
                    <label for="exampleInputPassword1">Project Description</label>
                    <input type="text" className="form-control" placeholder="Enter Project Description" required
                        onChange={desc => this.setState({ projectDescription: desc.target.value })} />
                </div>
                <div className="form-group">
                    <label for="exampleInputPassword1">Project Type</label>
                    <input type="text" className="form-control" placeholder="web / mobile" required
                        onChange ={type => this.setState({ projectType: type.target.value })} />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlFile1">Projects Image</label>
                    <input type="file" class="form-control-file" id="exampleFormControlFile1"
                        onChange={this.fileSelectedHandler} />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlFile1">Projects Logo</label>
                    <input type="file" class="form-control-file" id="exampleFormControlFile1"
                        onChange={(e)=> this.setState({logo:e.target.files[0]})} />
                </div>
                <button type="button" className="btn btn-primary" onClick={this.addProject}>Add Projects</button>

            </section>
        )
    }
}
